import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';

export const SubmitCommentWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;

  .editor-wrapper {
    min-height: 102px;
    width: 100%;
  }

  [contenteditable] {
    min-height: 86px;
  }
`;

export const SubmitCommentLoadingContainer = styled.div`
  width: 100%;
  height: 102px;

  display: flex;
  justify-content: center;
  align-items: center;

  & > .spinner-icon {
    ${infiniteRotationAnimation()}
  }
`;

export const SubmitCommentButton = styled.button`
  width: fit-content;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 16px 48px;

  border-radius: 100px;

  ${({ disabled }) =>
    disabled
      ? `
      background: rgba(255, 210, 95, 0.4);

      & > span {
        color: rgba(23, 28, 51, 0.5);
      }
    `
      : `
      background: var(--color-data-people-background);
    `}
`;

export const SubmitCommentButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
`;
